import React from "react";

export const toTitleCase = (text: string): string => {
    return text
        .toLowerCase()
        .split(/\s+/)
        .filter(w => w.length > 0)
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
};

interface ErrorPopupProps {
    message: string;
    onClose: () => void;
}

export function ErrorPopup({ message, onClose }: ErrorPopupProps): JSX.Element {
    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.4)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    background: 'white',
                    borderRadius: '8px',
                    padding: '24px',
                    minWidth: '280px',
                    maxWidth: '420px',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                }}
            >
                <h3 style={{ margin: 0, marginBottom: '12px', color: '#b91c1c' }}>
                    {toTitleCase(message)}
                </h3>
                <div style={{ textAlign: 'right' }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: '6px 14px',
                            border: 'none',
                            borderRadius: '4px',
                            background: '#0972d3',
                            color: 'white',
                            cursor: 'pointer'
                        }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}
